import React from 'react';
import { Container } from './styles';

type Props = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const Checkbox: React.FC<Props> = ({ ...rest }) => {
    return (
        <Container>
            <input type="checkbox" {...rest} />
            <span />
        </Container>
    );
};

export { Checkbox };
